import type { LearningExercise } from "../types";

// Fachlich gegen BGB geprüft (reviewStatus "reviewed"). Finale beta-ready-Freigabe durch Vincent.
// Enge Cloze (kind "cloze"): genau eine Lücke (___) im prompt, Auswahl per Dropdown aus options,
// answers = [Index der richtigen Auswahl]. Kein Freitext-Vergleich.
export const clozes: LearningExercise[] = [
  {
    id: "hj-cloze-001",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "cloze",
    topic: "BGB AT - Geschäftsfähigkeit",
    title: "Geschäftsfähigkeit des 16-Jährigen",
    prompt: "Der 16-jährige M ist nach § 106 BGB ___ geschäftsfähig.",
    options: ["voll", "beschränkt", "gar nicht", "unbeschränkt"],
    answers: [1],
    explanation: "§ 106 BGB: Wer das siebente, aber nicht das 18. Lebensjahr vollendet hat, ist beschränkt geschäftsfähig.",
    sourceIds: ["bgb106"],
    sources: [{ id: "bgb106", label: "§ 106 BGB", url: "https://www.gesetze-im-internet.de/bgb/__106.html" }],
    level: "Bekannt",
    levelNumber: 1,
    errorCategory: "Lücke",
    skillTags: ["bgb-at"],
    reviewStatus: "beta-ready",
  },
  {
    id: "hj-cloze-002",
    pathId: "hagen-jura",
    mode: "ausbildung",
    kind: "cloze",
    topic: "BGB AT - Anfechtung",
    title: "Anfechtungsfrist bei Irrtum",
    prompt: "Die Anfechtung wegen Irrtums muss nach § 121 Abs. 1 BGB ___ erfolgen.",
    options: ["binnen zwei Wochen", "unverzüglich", "binnen drei Jahren", "jederzeit"],
    answers: [1],
    explanation:
      "§ 121 Abs. 1 BGB: Die Anfechtung muss ohne schuldhaftes Zögern (unverzüglich) nach Kenntnis vom Anfechtungsgrund erfolgen.",
    sourceIds: ["bgb121"],
    sources: [{ id: "bgb121", label: "§ 121 BGB", url: "https://www.gesetze-im-internet.de/bgb/__121.html" }],
    level: "Abrufbar",
    levelNumber: 2,
    errorCategory: "Lücke",
    skillTags: ["bgb-at", "anfechtung"],
    reviewStatus: "beta-ready",
  },
];
